import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { MenuItem, ListItemIcon } from '@mui/material';

type StateSelectorProps = {
    selected?: boolean;
    onClick?: () => void;
};

export const StateSelector = ({
    onClick = () => undefined,
    selected,
}: StateSelectorProps): JSX.Element => {
    return (
        <MenuItem onClick={onClick}>
            <ListItemIcon sx={{ mx: -1 }}>
                {selected ? (
                    <RadioButtonUncheckedIcon />
                ) : (
                    <CheckCircleOutlineIcon />
                )}
            </ListItemIcon>
            {selected ? 'Снять выбор' : 'Выбрать'}
        </MenuItem>
    );
};
